module.exports = __webpack_public_path__ + "img/26.6280d912.png";